// useFeatureFlags — the workspace feature-flag gate for `useNavVisibility` (05) and features
// (contract 07 §9, ratified R2). Reads `enabledFeatures`/`disabledFeatures` off the workspace store,
// which the bootstrap `feature_flags` section hydrates. The interim `FeatureFlagsApi` that R2
// allowed as a temporary exception is NOT added: BE-07-04 shipped (feature flags in bootstrap,
// BE-ACC-02 / PR #7652), so the flags arrive via boot — no per-dataset HTTP action belongs here.
import { computed, type ComputedRef } from 'vue'

import { useWorkspaceStore } from '../stores/workspaceStore'

export interface UseFeatureFlags {
  enabled: ComputedRef<string[]>
  disabled: ComputedRef<string[]>
  /** `true` when `key` is enabled and not disabled (contract §7 `checkFlag`). */
  checkFlag: (key: string) => boolean
}

export function useFeatureFlags(): UseFeatureFlags {
  const workspaceStore = useWorkspaceStore()

  return {
    enabled: computed(() => workspaceStore.enabledFeatures),
    disabled: computed(() => workspaceStore.disabledFeatures),
    checkFlag: (key) => workspaceStore.checkFlag(key),
  }
}
